var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartFire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_1269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.67 20.6624C33.0523 16.4252 31.6763 14.7146 30.4613 13.2058C29.6265 12.1696 28.904 11.274 28.8373 9.71617C28.7644 8.05476 30.4148 6.78714 30.4322 6.77483C30.4779 6.74177 30.4968 6.68173 30.4805 6.62641C30.4642 6.57108 30.4204 6.53386 30.3594 6.52886C30.2515 6.51975 30.1144 6.50285 29.9537 6.47958C28.2852 6.26182 23.8584 5.67861 21.1968 11.1112C20.8465 11.8269 20.2253 12.3173 19.7239 12.2763C19.4027 12.2497 19.1601 12.0035 19.0289 11.5635C18.5064 9.81565 21.125 7.80818 21.1532 7.78743C21.1988 7.75437 21.2178 7.69433 21.2014 7.63901C21.1851 7.58368 21.136 7.54505 21.0804 7.54146C21.0221 7.53716 15.3081 7.21486 11.6279 12.1594C10.5089 13.6628 7.06022 19.043 9.64248 25.1474C12.2318 31.2679 14.5346 32.2558 14.5797 32.299C14.5946 32.3172 31.3903 30.8898 32.67 20.6624Z",
    fill: "url(#paint0_radial_453_1269)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M26.0342 14.8844C25.532 12.5644 24.9769 7.83257 30.0827 6.69538C26.5531 6.39789 23.4364 8.13034 22.5536 12.2278C21.9767 14.8984 22.8286 17.6461 22.8357 20.3769C22.8406 24.0668 21.5646 26.0292 20.7253 27.5453C27.4832 25.3136 26.6794 17.8541 26.0342 14.8844Z",
    fill: "url(#paint1_linear_453_1269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1108 17.1657C25.7132 15.9873 22.8957 20.0476 22.8957 20.0476C22.8957 20.0476 22.9426 15.2449 18.0775 13.9413C14.7496 13.0496 10.2505 14.6693 10.0465 21.0406C9.84321 27.4093 18.19 37.6514 18.19 37.6514C18.19 37.6514 30.5046 32.9483 33.5129 27.3312C36.5226 21.7089 33.7055 18.1289 30.1108 17.1657Z",
    fill: "url(#paint2_radial_453_1269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8176 16.211C14.8223 15.4724 16.374 15.0587 17.2732 16.2565C17.759 16.9047 17.2235 17.8256 16.5624 18.0957C15.596 18.4907 14.7977 18.6703 14.0555 19.4962C13.608 19.9934 13.2633 20.572 13.0016 21.1897C12.8993 21.4341 12.5502 21.4057 12.4855 21.1505C12.0385 19.4172 12.3515 17.2873 13.8176 16.211Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3539 21.4168C25 21.322 24.843 20.9147 25.0609 20.6193C25.4633 20.0788 25.9275 19.5719 26.4394 19.1514C27.1954 18.5274 28.3616 18.3586 28.8993 19.0038C29.45 19.6637 29.1066 20.5965 28.5054 20.9279C27.2152 21.6438 25.861 21.5527 25.3539 21.4168Z",
    fill: "#FF7043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7614 37.1063C14.6795 35.8247 13.4111 34.5365 12.923 31.9316C12.6741 30.5995 13.2122 28.5809 13.5258 27.326C13.8728 25.9356 13.7761 24.6273 13.7761 24.6273C14.5711 24.9989 15.6917 26.8702 15.6629 29.767C15.6148 34.7958 17.7614 37.1063 17.7614 37.1063Z",
    fill: "url(#paint3_linear_453_1269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7759 29.4504C31.7759 29.4504 34.5483 28.707 36.0371 25.5278C37.0093 23.4528 37.1302 21.1526 35.6136 18.4561C35.0752 17.4966 33.144 14.9947 34.9313 12.0539C34.9313 12.0539 32.1305 13.3785 31.9688 17.0775C31.7866 21.2438 35.1359 23.5878 31.7759 29.4504Z",
    fill: "url(#paint4_linear_453_1269)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1397 24.493C31.7206 24.8921 33.2346 29.6374 29.6785 33.2422C26.5152 36.4483 22.1559 35.9087 22.1559 35.9087C22.1559 35.9087 26.3635 33.475 28.5054 30.6689C30.4403 28.1385 31.1397 24.493 31.1397 24.493Z",
    fill: "url(#paint5_linear_453_1269)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_453_1269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8202 26.3756) rotate(15) scale(23.9161 24.3179)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3903,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6895,
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_453_1269",
    x1: 23.5848,
    y1: 19.4048,
    x2: 27.3222,
    y2: 7.02892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1645,
    stopColor: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_453_1269",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5788 36.1624) rotate(15) scale(27.4627)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1189,
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4848,
    stopColor: "#F44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8142,
    stopColor: "#B71C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_453_1269",
    x1: 15.0009,
    y1: 28.6953,
    x2: 15.7325,
    y2: 41.6893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0759,
    stopColor: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_453_1269",
    x1: 31.6873,
    y1: 19.1117,
    x2: 37.4865,
    y2: 24.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_453_1269",
    x1: 28.4841,
    y1: 23.5985,
    x2: 25.0944,
    y2: 43.9149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1873,
    stopColor: "#FFEB3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9339,
    stopColor: "#FFD600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_1269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(9.9585 0.133911) rotate(15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFire);
export default __webpack_public_path__ + "static/media/heartFire.4fc8393193043e82c3d77610c1a77335.svg";
export { ForwardRef as ReactComponent };